module.exports = __webpack_public_path__ + "static/media/26540964_1536963686388967_1556141463_o.fe3115f9.jpg";